import React, { useEffect } from "react";
import { useOktaAuth } from "@okta/okta-react";
import { toRelativeUrl } from "@okta/okta-auth-js";
import { Outlet, useNavigate } from "react-router-dom";
import { AUTH_ROUTES } from "../../utils/RoutesConstant";

export const SecureRoute = () => {
    const { oktaAuth, authState } = useOktaAuth();
    const navigate = useNavigate();

    useEffect(() => {
        if (!authState) {
            return;
        }

        if (!authState?.isAuthenticated) {
            const originalUri = toRelativeUrl(
                window.location.href,
                window.location.origin
            );
            oktaAuth.setOriginalUri(originalUri);
            navigate(`/${AUTH_ROUTES.Login}`, { replace: true });
        }
    }, [oktaAuth, authState, authState?.isAuthenticated]);

    return <Outlet />;
};
